var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.31965 6.99998L0 6.99998L0 7.99998L24 7.99998V6.99998H20.6803C19.29 6.99998 17.9624 6.42107 17.0164 5.40224L13.4656 1.57831C12.6743 0.726177 11.3257 0.726176 10.5344 1.57831L6.98362 5.40224C6.03756 6.42107 4.71 6.99998 3.31965 6.99998Z","fill":"#1A1A1A"}));
}

Arrow.defaultProps = {"width":"24","height":"8","viewBox":"0 0 24 8","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
